export default "__VITE_ASSET__DW0W4KY0__"